enum AccountType {
    Customer = "CUSTOMER",
    Institution = "INSTITUTION",
    ThirdParty = "THIRD_PARTY",
}
export default AccountType